import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGenehmigungDefinitionListStatus: 'idle',
    loadGenehmigungDefinitionListError: undefined as any,
    loadGenehmigungDefinitionListLastArgs: undefined as any,
    loadGenehmigungDefinitionStatus: 'idle',
    loadGenehmigungDefinitionError: undefined as any,
    saveGenehmigungDefinitionStatus: 'idle',
    saveGenehmigungDefinitionError: undefined as any,
    deleteGenehmigungDefinitionStatus: 'idle',
    deleteGenehmigungDefinitionError: undefined as any,

    genehmigungDefinitionList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadGenehmigungDefinitionList = createAsyncThunk('genehmigungDefinitionSlice/loadGenehmigungDefinitionList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().genehmigungDefinitionSlice.loadGenehmigungDefinitionListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgenehmdef/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGenehmigungDefinitionListStatus } = getState().genehmigungDefinitionSlice
        return loadGenehmigungDefinitionListStatus !== 'pending'
    }
})

export const loadGenehmigungDefinition = createAsyncThunk('genehmigungDefinitionSlice/loadGenehmigungDefinition', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgenehmdef/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGenehmigungDefinitionStatus } = getState().genehmigungDefinitionSlice
        return loadGenehmigungDefinitionStatus !== 'pending'
    }
})

export const saveGenehmigungDefinition = createAsyncThunk('genehmigungDefinitionSlice/saveGenehmigungDefinition', async ({ genehmigungDefinition }: any, { rejectWithValue }: any) => {
    let promises = []
    if (genehmigungDefinition?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisgenehmdef/${ genehmigungDefinition?.HDR_ID }/`,
            prepareData(genehmigungDefinition),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisgenehmdef/`,
            prepareData(genehmigungDefinition),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGenehmigungDefinitionStatus } = getState().genehmigungDefinitionSlice
        return saveGenehmigungDefinitionStatus !== 'pending'
    }
})

export const deleteGenehmigungDefinition = createAsyncThunk('genehmigungDefinitionSlice/deleteGenehmigungDefinition', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisgenehmdef/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGenehmigungDefinitionStatus } = getState().genehmigungDefinitionSlice
        return deleteGenehmigungDefinitionStatus !== 'pending'
    }
})

const GenehmigungDefinitionSlice = createSlice({
    name: 'genehmigungDefinitionSlice',
    initialState,
    reducers: {
        resetloadGenehmigungDefinitionListError: (state) => {
            state.loadGenehmigungDefinitionListError = undefined
        },
        resetloadGenehmigungDefinition: (state) => {
            state.formItem = undefined
            state.loadGenehmigungDefinitionError = undefined
        },
        resetloadGenehmigungDefinitionError: (state) => {
            state.loadGenehmigungDefinitionError = undefined
        },
        resetsaveGenehmigungDefinition: (state) => {
            state.formItem = undefined
            state.saveGenehmigungDefinitionError = undefined
        },
        resetsaveGenehmigungDefinitionError: (state) => {
            state.saveGenehmigungDefinitionError = undefined
        },
        resetdeleteGenehmigungDefinitionError: (state) => {
            state.deleteGenehmigungDefinitionError = undefined
        },
        removeFromGenehmigungDefinitionListById: (state, action) => {
            state.genehmigungDefinitionList = state.genehmigungDefinitionList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGenehmigungDefinitionListByIds: (state, action) => {
            state.genehmigungDefinitionList = state.genehmigungDefinitionList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.genehmigungDefinitionList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGenehmigungDefinitionListStatus = 'preloaded'
            state.loadGenehmigungDefinitionListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.genehmigungDefinitionList = []
            state.loadGenehmigungDefinitionListStatus = 'idle'
            state.loadGenehmigungDefinitionListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGenehmigungDefinitionList.pending, (state) => {
            state.loadGenehmigungDefinitionListStatus = 'pending'
            state.loadGenehmigungDefinitionListError = undefined
        })
        builder.addCase(loadGenehmigungDefinitionList.fulfilled, (state, action) => {
            state.loadGenehmigungDefinitionListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGenehmigungDefinitionListLastArgs = action.payload.args

            {
                state.genehmigungDefinitionList = action.payload.data

            }
        })
        builder.addCase(loadGenehmigungDefinitionList.rejected, (state, action) => {
            state.loadGenehmigungDefinitionListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGenehmigungDefinitionListError = action.error.message
            } else {
                state.loadGenehmigungDefinitionListError = action.payload
            }
        })

        builder.addCase(loadGenehmigungDefinition.pending, (state) => {
            state.loadGenehmigungDefinitionStatus = 'pending'
            state.loadGenehmigungDefinitionError = undefined
        })
        builder.addCase(loadGenehmigungDefinition.fulfilled, (state, action) => {
            state.loadGenehmigungDefinitionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.genehmigungDefinitionList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.genehmigungDefinitionList.push(newItem) }
                else { state.genehmigungDefinitionList[i] = { ...state.genehmigungDefinitionList[i], ...newItem } }
            }
        })
        builder.addCase(loadGenehmigungDefinition.rejected, (state, action) => {
            state.loadGenehmigungDefinitionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGenehmigungDefinitionError = action.error.message
            } else {
                state.loadGenehmigungDefinitionError = action.payload
            }
        })

        builder.addCase(saveGenehmigungDefinition.pending, (state) => {
            state.saveGenehmigungDefinitionStatus = 'pending'
            state.saveGenehmigungDefinitionError = undefined
        })
        builder.addCase(saveGenehmigungDefinition.fulfilled, (state, action) => {
            state.saveGenehmigungDefinitionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.genehmigungDefinitionList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.genehmigungDefinitionList.push(newItem) }
                else { state.genehmigungDefinitionList[i] = { ...state.genehmigungDefinitionList[i], ...newItem } }
            }
        })
        builder.addCase(saveGenehmigungDefinition.rejected, (state, action) => {
            state.saveGenehmigungDefinitionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGenehmigungDefinitionError = action.error.message
            } else {
                state.saveGenehmigungDefinitionError = action.payload
            }
        })

        builder.addCase(deleteGenehmigungDefinition.pending, (state) => {
            state.deleteGenehmigungDefinitionStatus = 'pending'
            state.deleteGenehmigungDefinitionError = undefined
        })
        builder.addCase(deleteGenehmigungDefinition.fulfilled, (state, action) => {
            state.deleteGenehmigungDefinitionStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.genehmigungDefinitionList = state.genehmigungDefinitionList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.genehmigungDefinitionList = state.genehmigungDefinitionList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteGenehmigungDefinition.rejected, (state, action) => {
            state.deleteGenehmigungDefinitionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGenehmigungDefinitionError = action.error.message
            } else {
                state.deleteGenehmigungDefinitionError = action.payload
            }
        })

    }
})

export const {
    resetloadGenehmigungDefinitionListError,
    resetloadGenehmigungDefinition,
    resetloadGenehmigungDefinitionError,
    resetsaveGenehmigungDefinition,
    resetsaveGenehmigungDefinitionError,
    resetdeleteGenehmigungDefinitionError,
    removeFromGenehmigungDefinitionListById,
    removeFromGenehmigungDefinitionListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GenehmigungDefinitionSlice.actions
export default GenehmigungDefinitionSlice.reducer
